const Welcome = () => import('~/pages/welcome').then(m => m.default || m)
const NotFound = () => import('~/pages/errors/404').then(m => m.default || m)

const Login = () => import('~/pages/auth/login-v2').then(m => m.default || m)
const Dashboard = () => import('~/pages/dashboard').then(m => m.default || m)
const BetaUsers = () => import('~/pages/beta-users').then(m => m.default || m)
const BetaUser = () => import('~/pages/beta-user').then(m => m.default || m)
const Affiliates = () => import('~/pages/affiliates').then(m => m.default || m)
const Affiliate = () => import('~/pages/affiliate').then(m => m.default || m)
const MonthlySummary = () => import('~/pages/monthly-summary').then(m => m.default || m)
const Orders = () => import('~/pages/orders').then(m => m.default || m)
const Order = () => import('~/pages/order').then(m => m.default || m)
const Customers = () => import('~/pages/customers').then(m => m.default || m)
const Customer = () => import('~/pages/customer').then(m => m.default || m)
const Ambassadors = () => import('~/pages/ambassadors').then(m => m.default || m)
const Ambassador = () => import('~/pages/ambassador').then(m => m.default || m)
const OutStocks = () => import('~/pages/out-stocks').then(m => m.default || m)
const CustomOrders = () => import('~/pages/custom-orders').then(m => m.default || m)
const CustomOrder = () => import('~/pages/custom-order').then(m => m.default || m)

const Summaries = () => import('~/pages/summaries').then(m => m.default || m)
const Summary = () => import('~/pages/summary').then(m => m.default || m)
const ClientList = () => import('~/pages/client-list').then(m => m.default || m)
const ClientListOrder = () => import('~/pages/client-list-order').then(m => m.default || m)
const AffiliateOrders = () => import('~/pages/affiliate-orders').then(m => m.default || m)
const AffiliateSummaries = () => import('~/pages/affiliate-summaries').then(m => m.default || m)
const AffiliateSummary = () => import('~/pages/affiliate-summary').then(m => m.default || m)
const AffiliatePayoutSummaries = () => import('~/pages/affiliate-payout-summaries').then(m => m.default || m)
const AffiliatePayoutSummary = () => import('~/pages/affiliate-payout-summary').then(m => m.default || m)
const AffiliatePayoutSummaryOrders = () => import('~/pages/affiliate-payout-summary-orders').then(m => m.default || m)

const Users = () => import('~/pages/users').then(m => m.default || m)
const User = () => import('~/pages/user').then(m => m.default || m)
const Profile = () => import('~/pages/settings/profile').then(m => m.default || m)

export default [
  { path: '/', name: 'home', component: BetaUsers },

  { path: '/login', name: 'login', component: Login },
  { path: '/beta-users', name: 'beta-users', component: BetaUsers },
  { path: '/beta-user/:id', name: 'beta-user', component: BetaUser },
  { path: '/affiliates', name: 'affiliates', component: Affiliates},
  { path: '/affiliate/:id', name: 'affiliate', component: Affiliate},
  { path: '/summary/:year/:month/:id', name: 'monthly-summary', component: MonthlySummary},
  { path: '/orders', name: 'orders', component: Orders},
  { path: '/order/:id', name: 'order', component: Order},
  { path: '/customers', name: 'customers', component: Customers },
  { path: '/customer/:id', name: 'customer', component: Customer },
  { path: '/ambassadors', name: 'ambassadors', component: Ambassadors },
  { path: '/ambassador/:id', name: 'ambassador', component: Ambassador },
  { path: '/out-stocks', name: 'out-stocks', component: OutStocks },
  { path: '/custom-orders', name: 'custom-orders', component: CustomOrders},
  { path: '/custom-order/:id', name: 'custom-order', component: CustomOrder},

  { path: '/summaries/', name: 'summaries', component: Summaries},
  { path: '/summary/:year/:id', name: 'summary', component: Summary},
  { path: '/client-list/', name: 'client-list', component: ClientList},
  { path: '/client-list-order/:id', name: 'client-list-order', component: ClientListOrder},
  { path: '/affiliate-orders/', name: 'affiliate-orders', component: AffiliateOrders},
  { path: '/affiliate-summaries/', name: 'affiliate-summaries', component: AffiliateSummaries},
  { path: '/affiliate-summary/:id', name: 'affiliate-summary', component: AffiliateSummary},
  { path: '/affiliate-payout-summaries/', name: 'affiliate-payout-summaries', component: AffiliatePayoutSummaries},
  { path: '/affiliate-payout-summary/:year/:id', name: 'affiliate-payout-summary', component: AffiliatePayoutSummary},
  { path: '/affiliate-payout-summary/:year/:month/:id', name: 'affiliate-payout-summary-order', component: AffiliatePayoutSummaryOrders},

  { path: '/users', name: 'users', component: Users },
  { path: '/user/:id', name: 'user', component: User },
  { path: '/profile', name: 'profile', component: Profile },

  { path: '*', component: NotFound }
]



// WEBPACK FOOTER //
// ./resources/js/router/routes.js